import { render, staticRenderFns } from "./AdminViewOption.vue?vue&type=template&id=72ba7b03&"
import script from "./AdminViewOption.vue?vue&type=script&lang=js&"
export * from "./AdminViewOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports